import { useActionData, useLoaderData } from "@remix-run/react";
import ActionAlert from "./ActionAlert";

type FlashData = {
  successMessage?: string;
  warningMessage?: string;
  errorMessage?: string;
};

export default function FlashMessage() {
  const loaderData = useLoaderData<FlashData>();
  const actionData = useActionData<FlashData>();
  return <ActionAlert actionData={{ ...loaderData, ...actionData }} />;
}
